import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { TranslateModule } from '@ngx-translate/core';
import { DropdownModule } from '../dropdown/dropdown.module';
import { DropDownMenuComponent } from './drop-down-menu.component';

@NgModule({
  declarations: [DropDownMenuComponent],
  exports: [DropDownMenuComponent],
  entryComponents: [DropDownMenuComponent],
  imports: [CommonModule, AngularSvgIconModule, TranslateModule, DropdownModule]
})
export class DropdownMenuModule {}

export { DropDownMenuComponent };

export * from './drop-down-menu.types';
